<div
  class="relative flex h-full flex-col gap-2 rounded-2xl border border-shikenso-purple-base-12 bg-shikenso-base-white p-4"
>
  <div class="flex items-center justify-between w-full gap-1 min-w-0">
    <span
      class="text-xs uppercase tracking-wide text-shikenso-purple-base-60 line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="title()"
    >
      {{ title() }}
    </span>

    @if (infoMessage()) {
      <button
        mat-icon-button
        type="button"
        class="mat-secondary-transparent-button-color mat-micro-icon-button !p-0 flex-shrink-0"
        matTooltipPosition="above"
        [attr.aria-label]="infoMessage()"
        [matTooltip]="infoMessage()!"
      >
        <app-icon src="icons/info-circle.svg" alt="Info" [size]="16" />
      </button>
    }
  </div>

  @if (loading()) {
    <div class="flex items-center justify-between">
      <ngx-skeleton-loader class="h-8 w-2/3" [theme]="{ height: '32px', width: '66%', 'border-radius': '4px' }" />

      @if (comparing()) {
        <ngx-skeleton-loader class="h-5 w-16" [theme]="{ height: '20px', width: '64px', 'border-radius': '100vw' }" />
      }
    </div>
  } @else {
    <div class="flex items-center justify-between">
      <div class="flex items-baseline gap-1 font-bold">
        <span class="text-2xl text-shikenso-purple-base" data-testid="event-kpi-card-value">{{
          formattedValue()
        }}</span>

        @if (formattedTotalValue()) {
          <span class="text-sm text-shikenso-purple-base-60">/{{ formattedTotalValue() }}</span>
        }
      </div>

      @if (!loading() && formattedPercentageChange()) {
        <div
          class="flex items-center gap-0.5 rounded-full px-2 py-0.5 text-xs font-semibold flex-shrink-0"
          [class.bg-shikenso-success-light]="trendTone() === 'positive'"
          [class.text-shikenso-success-base]="trendTone() === 'positive'"
          [class.bg-shikenso-error-light]="trendTone() === 'negative'"
          [class.text-shikenso-error-base]="trendTone() === 'negative'"
          [class.bg-shikenso-gray-200]="trendTone() === 'neutral'"
          [class.text-shikenso-purple-base-60]="trendTone() === 'neutral'"
        >
          @if (trend() === 'up') {
            <app-icon
              src="icons/caret-up.svg"
              alt="Up"
              [size]="16"
              [color]="trendTone() === 'positive' ? 'var(--shikenso-success-base)' : 'var(--shikenso-error-base)'"
            />
          } @else if (trend() === 'down') {
            <app-icon
              src="icons/caret-down.svg"
              alt="Down"
              [size]="16"
              [color]="trendTone() === 'positive' ? 'var(--shikenso-success-base)' : 'var(--shikenso-error-base)'"
            />
          } @else {
            <span>–</span>
          }

          <span>{{ formattedPercentageChange() }}</span>
        </div>
      }
    </div>
  }

  @if (enableProgressBar()) {
    <div class="h-2.5 w-full rounded-full bg-shikenso-gray-300 overflow-hidden">
      <div
        class="h-full rounded-full bg-shikenso-purple-100 transition-all duration-300"
        [style.width.%]="loading() ? 0 : progressPercentage()"
      ></div>
    </div>
  }
</div>
